import cn from 'classnames'
import { IconArrowRightDefault } from '@mc/design-system'
import { useTranslation } from '@mc/i18n'
import classes from './WhatYouWillLearn.module.scss'

export const WhatYouWillLearn = () => {
  const { t } = useTranslation('@mc/next')

  return (
    <div className='container mc-mt-10 mc-mt-sm-5 mc-mb-9'>
      <p className='d-inline-flex'>
        <span className='mc-text-h4'>
          {t('subcategoryPage.whatYouWillLearn')}
        </span>
        <IconArrowRightDefault
          className={cn('align-self-center', classes.redArrow)}
          size='sm'
        />
      </p>
    </div>
  )
}
